/**
 * Constantes de l'onglet « Avis Google » du Service client, partagées entre le backend (filtre
 * « hors délai », schéma Vine de la réponse) et le back-office (badge, compteur du champ).
 */

/** Délai de réponse à un avis, en heures (cadrage omnicanal), compté depuis sa création. */
export const googleReviewReplySlaHours = 48

/** Longueur maximale d'une réponse publique, après trim (limite de l'API Google). */
export const googleReviewReplyMaxLength = 4096
